import './style.scss'

import { mapGetters } from 'vuex'
import getPathFromUrl from 'util/getPathFromUrl'
import verifyLeadingSlashLang from 'util/verifyLeadingSlashLang'

export default {
  name: 'Link',
  props: ['title', 'externalLink', 'externalLinkUrl', 'internalLink', 'internalLinkAbsolute', 'button'],
  computed: {
    ...mapGetters(['lang']),
    internalLinkPath () {
      return this.internalLink ? getPathFromUrl(this.internalLink) : ''
    },
    aboluteLink () {
      return this.internalLinkAbsolute ? getPathFromUrl(this.internalLinkAbsolute) : ''
    }
  },
  methods: {
    getLinkMarkup () {
      const { title, externalLink, externalLinkUrl, internalLinkPath, internalLinkAbsolute, aboluteLink, button, lang } = this
      let markup
      if (button) {
        markup = <button class='Link__inner'>{title}</button>
      } else if (externalLink) {
        markup = <a class='Link__inner' href={externalLinkUrl} target='_blank' rel='noopener'>{title}</a>
      } else if (internalLinkAbsolute) {
        markup = <router-link class='Link__inner' to={aboluteLink}>{title}</router-link>
      } else {
        markup = <router-link class='Link__inner' to={verifyLeadingSlashLang(internalLinkPath, lang)}>{title}</router-link>
      }
      return markup
    }
  },
  render (h) {
    return (
      <div class='Link'>
        {this.getLinkMarkup()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Link/index.js